"use client";

import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";
import { toast } from "sonner";

// Reads the redirect flag from window.location.search (NOT useSearchParams) so
// this component needs no <Suspense> boundary. The root layout must stay
// Suspense-free — a layout-level Suspense is one leg of the Next.js App Router
// #310 trigger combo (with the home redirect() + the sign-in server action).
// See app/layout.tsx and CLAUDE.md.
//
// Keyed on pathname: every toast flow arrives via a pathname change
// (/sign-in→/dashboard/*, /new-venue→/dashboard, /dashboard/*→/), so the effect
// fires in each case and reads the freshly-updated query string off window.
const ToastOnRedirect = () => {
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const signedIn = params.get("signedIn") === "true";
    const signedOut = params.get("signedOut") === "true";
    const registered = params.get("registered") === "true";

    if (signedIn) toast.success("Signed in successfully!");
    if (signedOut) toast.success("You were logged out");
    if (registered)
      toast.success("Welcome! Your loyalty card is ready to share.");

    if (signedIn || signedOut || registered) {
      router.replace(pathname);
    }
  }, [pathname, router]);

  return null;
};

export default ToastOnRedirect;
